import React from "react";
import passwordrestored from "../../images/password-restored.svg";
import BuildProfileLayout from "./BuildProfileLayout";

const BuildProfileSuccess = () => {
  return (
    <BuildProfileLayout>
      <div className="login-cover">
        <div className="login-box password-restored buildsuccess">
          <h2>Great! You have created Your Council profile</h2>

          <div className="restore-password-img">
            <img src={passwordrestored} alt="restore-password" />
          </div>
          <div className="login-form">
            <a href="/dashboard">
              <div className="form-submit">
                <button className="submit-btn">Go to Dashboard</button>
              </div>
            </a>
          </div>
        </div>
      </div>
    </BuildProfileLayout>
  );
};

export default BuildProfileSuccess;
